const renderCookiePolicy = (parent, element) => {
  const POLICY = `cookie-policy`;
  const docLang = document.documentElement.lang;
  const policyElement = document.createElement(`div`);
  policyElement.classList.add(`cookies`);

  if (document.cookie.search(POLICY) === -1) {
    let policyLayout = `
    <div class="cookies__wrapper">
      <svg class="cookies__cookie" width="32" height="32">
        <use xlink:href="/img/sprite.svg#s-icon-cookie"></use>
      </svg>
      <p class="cookies__text">By using this site, you agree to our <a href="/en_US/privacy-policy.html" class="cookies__link">Privacy Policy</a> and <a href="/en_US/cookie-policy.html" class="cookies__link">Use Of Cookies</a>.</p>
      <div class="cookies__closeWrapper">
        <svg class="cookies__close" width="16" height="16">
          <use xlink:href="/img/sprite.svg#s-icon-ui16-x"></use>
        </svg>
      </div>
    </div>`;
    if (docLang === `de`) {
    policyElement.classList.add(`cookies--de`);
    policyLayout = `
      <div class="cookies__wrapper">
        <svg class="cookies__cookie" width="32" height="32">
          <use xlink:href="/img/sprite.svg#s-icon-cookie"></use>
        </svg>
        <p class="cookies__text">Durch die Nutzung dieser Website stimmen Sie unserer <a href="/de_DE/privacy-policy.html" class="cookies__link">Datenschutzrichtlinie</a> und der <a href="/de_DE/cookie-policy.html" class="cookies__link">Verwendung von Cookies</a> zu.</p>
        <div class="cookies__closeWrapper">
          <svg class="cookies__close" width="16" height="16">
            <use xlink:href="/img/sprite.svg#s-icon-ui16-x"></use>
          </svg>
        </div>
      </div>`;
    }
    policyElement.innerHTML = policyLayout;
    const cookiesClose = policyElement.querySelector(`.cookies__closeWrapper`);

    cookiesClose.addEventListener(`click`, () => {
      policyElement.remove();
      document.cookie = `${POLICY}=${(new Date()).getTime()}`;
    });
    if (element) {
      parent.insertBefore(policyElement, element);
    } else {
      parent.appendChild(policyElement);
    }
  }
};

window.renderCookiePolicy = renderCookiePolicy;